import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentStatusPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [plan, setPlan] = useState('');
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const order_id = searchParams.get('order_id');
    const plan_id = searchParams.get('plan');
    if (!order_id) { navigate('/pricing'); return; }
    setPlan(plan_id || '');

    const verify = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await fetch(`${API_URL}/api/cashfree/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ order_id })
        });
        const data = await res.json();
        if (data.success) { setStatus('success'); setTimeout(() => navigate('/dashboard'), 3000); }
        else { setStatus('failed'); }
      } catch (e) { setStatus('failed'); }
    };
    verify();
  }, []);

  return (
    <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-[#0f172a]' : 'bg-gray-50'}`}>
      <div className={`rounded-2xl shadow-sm border p-10 max-w-md w-full text-center ${isDarkMode ? 'bg-[#111827] border-gray-700' : 'bg-white border-gray-100'}`}>
        {status === 'verifying' && (
          <><Loader2 size={48} className="animate-spin text-blue-500 mx-auto mb-4" />
          <h2 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Verifying Payment...</h2>
          <p className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>Please wait while we confirm your payment.</p></>
        )}
        {status === 'success' && (
          <><CheckCircle size={56} className="text-green-500 mx-auto mb-4" />
          <h2 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Payment Successful!</h2>
          <p className={`mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Your <strong className="capitalize">{plan}</strong> plan has been activated.</p>
          <p className={`text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Redirecting to dashboard...</p></>
        )}
        {status === 'failed' && (
          <><XCircle size={56} className="text-red-500 mx-auto mb-4" />
          <h2 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Payment Failed</h2>
          <p className={`mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>No amount has been deducted. Please try again.</p>
          <button onClick={() => navigate('/pricing')} className="px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700">
            Try Again
          </button></>
        )}
      </div>
    </div>
  );
}
